import React from 'react'
import { Mission } from '../../../api/missions'
import { useCreateWorkPeriodMutation } from '../../../queries/work-periods'
import AddWorkPeriodForm from '../../work-periods/forms/add-work-period-form'
import ConfirmationModal, {
  ConfirmationModalBaseProps,
} from '../../confirmation-modal/confirmation-modal'

interface AddWorkPeriodModalProps extends ConfirmationModalBaseProps {
  mission: Mission
}

/**
 * Modal that wraps AddWorkPeriodForm in a confirmation dialog.
 * Handles create mutation and closes on success.
 */
const AddWorkPeriodModal: React.FC<AddWorkPeriodModalProps> = ({ show, hide, mission }) => {
  const createWorkPeriodMutation = useCreateWorkPeriodMutation()

  const handleSubmit = (payload: { start: { date: Date }; end: { date: Date } }) => {
    createWorkPeriodMutation.mutate(
      {
        missionId: mission._id,
        start: payload.start,
        end: payload.end,
      },
      {
        onSuccess: () => hide(),
      },
    )
  }

  return (
    <AddWorkPeriodForm
      mission={mission}
      onSubmit={handleSubmit}
      mutation={createWorkPeriodMutation}
      formKey={show ? 'open' : 'closed'}
    >
      {({ handleSubmit: formHandleSubmit, content }) => (
        <ConfirmationModal
          show={show}
          onCancel={hide}
          onConfirm={() => formHandleSubmit()}
          confirmButtonLabel="Ajouter"
          cancelButtonLabel="Annuler"
          confirmButtonProps={{
            disabled: createWorkPeriodMutation.isLoading,
          }}
        >
          {content}
        </ConfirmationModal>
      )}
    </AddWorkPeriodForm>
  )
}

export default AddWorkPeriodModal
